
import axios from "axios";
import { BaseApiUrl } from "@/globals";
export default {
  name: "HistoricodeStatus",
  data: () => ({
    historico: [],
    headers: [
      { text: "ID", value: "id", align: "center",width: 30 },
      { text: "Data", value: "data", align: "center", width: 50 },
      { text: "Hora", value: "hora", align: "center", width: 50 },
      { text: "Status", value: "status", align: "center" },
      { text: "Usuário", value: "nome_usuario", align: "start" },
      { text: "Obs", value: "obs", align: "center" },
    ]
  }),
  methods: {
    getHistorico() {
      axios
        .get(`${BaseApiUrl}/relatorio/historico`)
        .then(res => (this.historico = res.data.reverse()));
    }
  },
  mounted() {
    this.getHistorico();
  },
  filters: {
    dataFormatada: function(value) {
      let d = value.split("-");
      let dia = d[2].split("T")[0];
      let mes = d[1];
      let ano = d[0];

      return `${dia}/${mes}/${ano}`;
    },
    horaFormatada: function(value) {
      if (value) {
        let hora = value.split("T")[1].split(".")[0];
        return hora;
      }
    },
  }
};
